import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import REGEXP from 'constant/REGEXP'

const validate = values => {
    const errors = {}
    if (!values.email) errors.email = 'Your email?'
    else if (!REGEXP.validations.email.test(values.email)) errors.email = 'Invalid format.'
    return errors
}

class MagicLoginForm extends Component {
    render() {
        const { handleSubmit, pristine, submitting, error } = this.props
        return (
            <form onSubmit={ handleSubmit }>
                <Field name='email' component={ InputField } type='email' placeholder='Email...' label='Email'/>
                <button name='submit-login' type='submit' disabled={ pristine || submitting }>Login</button>
                {
                    error ? <p className='error' id='login-error'>{ error }</p> : null
                }
            </form>
        )
    }
}

MagicLoginForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

export default MagicLoginForm = reduxForm({
    form: 'magicLogin',
    validate
})(MagicLoginForm)


// WEBPACK FOOTER //
// ./src/client/features/session/components/MagicLoginForm.jsx